import { Params, useQueryWithParams } from 'hooks/useQueryWithParams'
import { findAllAdmissionExpert, findAllAdmissionExpertVariables } from '__generatedTypes__/findAllAdmissionExpert'
import { GET_ADMISSION_EXPERTS } from 'queries/admissionExpert'
import { OrderDirection, ServicePageTypeEnum } from '__generatedTypes__/globalTypes'

type ExpertsFilters = {
  page: ServicePageTypeEnum
}

export function castParams({ page, take, filters }: Params<ExpertsFilters>): findAllAdmissionExpertVariables {
  return {
    params: {
      skip: (page - 1) * take,
      take,
      where: {
        page: filters.page,
      },
      order: {
        createdAt: OrderDirection.DESC,
      },
    },
  }
}

export function useAdmissionExperts() {
  return useQueryWithParams<
    findAllAdmissionExpert,
    findAllAdmissionExpertVariables,
    'findAllAdmissionExpert',
    'items',
    'count',
    ExpertsFilters
  >(GET_ADMISSION_EXPERTS, 'findAllAdmissionExpert', 'items', 'count', castParams, undefined, {
    fetchPolicy: 'network-only',
  })
}
